// src/routes/HomeRoutes.tsx
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomeLayout from "../layouts/HomeLayout";
import NotFound from "../pages/404";
import ServicesPage from "../pages/ServicePage";
import PPPCalculator from "../components/Funnels/PPPCalculator";
import NigeriaTaxCalculator from "../components/Funnels/TaxReform/NigeriaTaxCalculator";

import NigerianMarketAnalysisDashboard from "../components/SkillToSales/NigerianMarketAnalysisDashboard";
import ProfitableSweetSpotFinder from "../components/SkillToSales/ProfitableSweetSpotFinder";
import MonetizationStrategy from "../components/Funnels/SkillToSaleQuizFunnel/MonetizationStrategy";
import SuccessScreen from "../components/Funnels/SkillToSaleQuizFunnel/SuccessScreen";
import IncomePotentialQuiz from "../components/Funnels/IncomePotentialQuiz";
import SkillToSalesQuiz from "../components/Funnels/SkillToSaleQuizFunnel/SkillToSalesQuiz";
import SkillToSales from "../components/SkillToSales";
import RoadmapPage from "../pages/RoadmapPage";
import DBCModule1 from "../pages/courses/DBCCourse/DBCModule1";
import DBCLandingPage from "../pages/courses/DBCCourse/DBCLandingPage";
import DBCCheckout from "../pages/courses/DBCCourse/DBCCheckout";
import DBCWealthMethodOrderBump from "../pages/courses/DBCCourse/DBCWealthMethodOrderBump";
import WebinarRegistration from "../pages/courses/DBCCourse/WebinarRegistration";
import FaithThatWorksPage from "../pages/FaithThatWorksPage";
import AboutMePage from "../pages/AboutMePage";
import CustomFunnelPage from "../pages/CustomFunnelPage";
import MonetizeKnowledgePage from "../pages/MonetizeKnowledgePage";
import DBCWebinar from "../pages/courses/DBCCourse/DBCWebinar";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";
import Contact from "../pages/Contact";
import CustomFunnelSalesPage from "../components/CustomFunnel/CustomFunnelSalesPage";
import DemoViewPage from "../components/CustomFunnel/DemoViewPage";
import CustomFunnelPaymentPage from "../components/CustomFunnel/CustomFunnelPaymentPage";
import DemoRequestPage from "../components/CustomFunnel/DemoRequestPage";
import DataPolicy from "../pages/DataPolicy";
import SignInPage from "../pages/auth/SignInPage";
import DBCBuyPage from "../pages/courses/DBCCourse/DBCBuyPage";

const Home = lazy(() => import("../pages/HomePage"));

const LoadingFallback: React.FC = () => (
  <div className="min-h-[40vh] flex items-center justify-center">
    <div className="animate-spin h-8 w-8 border-4 border-t-[#E50000] border-[#E9EDF3] rounded-full" />
  </div>
);

export const HomeRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route
          path="/"
          element={
            <HomeLayout>
              <Home />
            </HomeLayout>
          }
        />
        <Route
          path="/services"
          element={
            <HomeLayout>
              <ServicesPage />
            </HomeLayout>
          }
        />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route
          path="*"
          element={
            <HomeLayout>
              <NotFound />
            </HomeLayout>
          }
        />
        <Route
          path="/sign-in"
          element={
            <HomeLayout>
              <SignInPage />
            </HomeLayout>
          }
        />
        <Route
          path="/about"
          element={
            <HomeLayout>
              <AboutMePage />
            </HomeLayout>
          }
        />
        <Route
          path="/privacy"
          element={
            <HomeLayout>
              <Privacy />
            </HomeLayout>
          }
        />
        <Route
          path="/privacy/policy"
          element={
            <HomeLayout>
              <DataPolicy />
            </HomeLayout>
          }
        />
        <Route
          path="/terms"
          element={
            <HomeLayout>
              <Terms />
            </HomeLayout>
          }
        />
        <Route
          path="/contact"
          element={
            <HomeLayout>
              <Contact />
            </HomeLayout>
          }
        />
        <Route
          path="/events/monetize-knowledge"
          element={
            <HomeLayout>
              <MonetizeKnowledgePage />
            </HomeLayout>
          }
        />

        {/* Custom Funnel / Launch Kit Naija */}
        <Route
          path="/sales-funnel"
          element={
            <HomeLayout>
              <CustomFunnelPage />
            </HomeLayout>
          }
        />
        <Route path="/sales-funnel/sales" element={<CustomFunnelSalesPage />} />
        <Route
          path="/sales-funnel/sales/demo-request"
          element={<DemoRequestPage />}
        />
        <Route
          path="/sales-funnel/sales/pay"
          element={<CustomFunnelPaymentPage />}
        />

        {/*
          Webinar / Demo view — access is gated by uniqueId.
          The :uniqueId param is a UUID generated at registration time
          and validated server-side via GET /api/custom-funnel/webinar/:uniqueId.
          Visiting /sales-funnel/webinar without a uniqueId shows the access-denied screen.
        */}
        <Route
          path="/sales-funnel/webinar/:uniqueId"
          element={<DemoViewPage />}
        />

        {/* Pricing */}
        <Route
          path="/pricing/ppp"
          element={
            <HomeLayout>
              <PPPCalculator />
            </HomeLayout>
          }
        />

        {/* Personal Finance */}
        <Route
          path="/personal-finance/tax-calculator"
          element={
            <HomeLayout>
              <NigeriaTaxCalculator />
            </HomeLayout>
          }
        />

        {/* Skill To Sales */}
        <Route
          path="/skill-to-sales"
          element={
            <HomeLayout>
              <SkillToSales />
            </HomeLayout>
          }
        />
        <Route path="/skill-to-sales/quiz" element={<SkillToSalesQuiz />} />
        <Route
          path="/skill-to-sales/income-quiz"
          element={<IncomePotentialQuiz />}
        />
        <Route
          path="/skill-to-sales/quiz/success"
          element={<SuccessScreen />}
        />
        <Route
          path="/skill-to-sales/monetization-strategy"
          element={
            <HomeLayout>
              <MonetizationStrategy />
            </HomeLayout>
          }
        />
        <Route
          path="/skill-to-sales/pro-finder"
          element={<ProfitableSweetSpotFinder />}
        />
        <Route
          path="/skill-to-sales/naija-market"
          element={
            <HomeLayout>
              <NigerianMarketAnalysisDashboard />
            </HomeLayout>
          }
        />

        <Route
          path="/roadmap/:token"
          element={
            <HomeLayout>
              <RoadmapPage />
            </HomeLayout>
          }
        />

        {/* DBC Routes */}
        <Route path="/dbc/module-1" element={<DBCModule1 />} />
        <Route path="/dbc" element={<DBCBuyPage />} />
        <Route path="/dbc/free-training" element={<WebinarRegistration />} />
        <Route path="/dbc/dib-webinar" element={<DBCWebinar />} />
        <Route path="/dbc-sl" element={<DBCLandingPage />} />
        <Route path="/dbc/buy" element={<DBCCheckout />} />
        <Route path="/dbc/wm-ord-bmp" element={<DBCWealthMethodOrderBump />} />

        {/* Faith that Works */}
        <Route
          path="/faith-that-works"
          element={
            <HomeLayout>
              <FaithThatWorksPage />
            </HomeLayout>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default HomeRoutes;
